import { z } from 'zod'

// NOTE (inspection low): amount min(0) is valid only PRE-normalization —
// discount rows are negated AFTER validation (the engine emits negative
// amounts). Do not reuse this schema on the normalized/served payload.
export const invoiceItemSchema = z.object({
  item_type: z.string().min(1),
  description: z.string(),
  quantity: z.number().int().min(1),
  unit_price: z.number().min(0),
  amount: z.number().min(0),
})

export const invoiceSchema = z
  .object({
    // Either lease_id (for tenant invoices) or customer_id (for external parkers) must be set.
    lease_id: z.number().int().positive().optional().nullable(),
    customer_id: z.number().int().positive().optional().nullable(),
    billed_at: z.string().min(1, 'Billed date is required'),
    due_at: z.string().min(1, 'Due date is required'),
    items: z.array(invoiceItemSchema).min(1, 'At least one item is required'),
  })
  .refine((data) => data.lease_id != null || data.customer_id != null, {
    message: 'Either a lease or a customer must be selected',
    path: ['lease_id'],
  })

export type InvoiceItemData = z.infer<typeof invoiceItemSchema>
export type InvoiceFormData = z.infer<typeof invoiceSchema>
